/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManualAdjustmentModel } from '../../models/manual-adjustment-model';

export interface EncounterManualAdjustmentTechniquesGet$Params {
}

export function encounterManualAdjustmentTechniquesGet(http: HttpClient, rootUrl: string, params?: EncounterManualAdjustmentTechniquesGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<ManualAdjustmentModel>>> {
  const rb = new RequestBuilder(rootUrl, encounterManualAdjustmentTechniquesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<Array<ManualAdjustmentModel>>;
    })
  );
}

encounterManualAdjustmentTechniquesGet.PATH = '/Encounter/ManualAdjustmentTechniques';
